/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_AuditorInputs */

const en_audit_auditor = /** @type {(inputs: Audit_AuditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auditor`)
};

const es_audit_auditor = /** @type {(inputs: Audit_AuditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auditor`)
};

/**
* | output |
* | --- |
* | "Auditor" |
*
* @param {Audit_AuditorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_auditor = /** @type {((inputs?: Audit_AuditorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_AuditorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_auditor(inputs)
	return es_audit_auditor(inputs)
});